import { render, staticRenderFns } from "./AppFormDialog.vue?vue&type=template&id=b6b501cc"
import script from "./AppFormDialog.vue?vue&type=script&lang=js"
export * from "./AppFormDialog.vue?vue&type=script&lang=js"
import style0 from "./AppFormDialog.vue?vue&type=style&index=0&id=b6b501cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports